<div class="container-aws-ses">

  <div class="aws-ses-scroll">
    <div class="label-lateral">
      <span class="label">Configuração de Envio</span>
    </div>

    <div class="container-aws-ses__content flex-direction-column gap-15">
      <app-slide-toggle-padrao
        [carregandoInfo]="carregando"
        [valor]="parametroAwsSes.ativo"
        (changeValue)="parametroAwsSes.ativo = $event"
      >
      </app-slide-toggle-padrao>

      <app-form-field
        label="Access Key ID"
        heightFormField="35px"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametroAwsSes.accessKeyId"
        (changeValue)="parametroAwsSes.accessKeyId = $event"
      >
      </app-form-field>

      <app-form-field
        label="Secret Access Key"
        heightFormField="35px"
        [isSenha]="true"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametroAwsSes.secretAccessKey"
        (changeValue)="parametroAwsSes.secretAccessKey = $event"
      >
      </app-form-field>

      <app-form-field
        label="Region"
        heightFormField="35px"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametroAwsSes.region"
        (changeValue)="parametroAwsSes.region = $event"
      >
      </app-form-field>

      <app-form-field
        label="E-mail de Envio"
        heightFormField="35px"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametroAwsSes.emailRemetente"
        (changeValue)="parametroAwsSes.emailRemetente = $event"
      >
      </app-form-field>

      <div class="campos-limite">
        <app-form-field
          label="Limite de Mensagens"
          heightFormField="35px"
          type="number"
          [widthFormField]="'100%'"
          [carregandoInfo]="carregando"
          [value]="parametroAwsSes.limiteMsg"
          (changeValue)="converterEAtribuirLimiteMsg($event)">
        </app-form-field>

        <app-form-field
          label="Tempo em minutos"
          heightFormField="35px"
          type="number"
          [widthFormField]="'100%'"
          [carregandoInfo]="carregando"
          [value]="parametroAwsSes.limiteMsgsMinutos"
          (changeValue)="converterEAtribuirLimiteMinuto($event)">
        </app-form-field>
      </div>

      <app-form-field
        label="Valor Unitário msg"
        heightFormField="35px"
        type="number"
        [textPrefix]="obterSimboloMoeda()"
        [step]="0.001"
        [min]="0"
        placeholder="0.000"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametroAwsSes.valorUnitarioMsg"
        (changeValue)="converterEAtribuirValorUnitario($event)">
      </app-form-field>

      <app-select-one
        label="Moeda do valor por mensagem"
        widthFormField="100%"
        heightFormField="35px"
        campo="nome"
        [listaInput]="opcoesMoeda"
        [itemSelecionado]="obterMoeda()"
        (selecionarItem)="selecionarMoeda($event)">
      </app-select-one>
    </div>

    <div class="label-lateral secao-api">
      <span class="label">Acesso API AWS SES</span>
    </div>

    <div class="container-aws-ses__content flex-direction-column gap-15">
      <app-form-field
        label="Usuário"
        heightFormField="35px"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametroAwsSes.usuario"
        (changeValue)="parametroAwsSes.usuario = $event"
      >
      </app-form-field>

      <app-form-field
        label="Senha"
        heightFormField="35px"
        [isSenha]="true"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregando"
        [value]="parametroAwsSes.senha"
        (changeValue)="parametroAwsSes.senha = $event"
      >
      </app-form-field>
    </div>
  </div>

  <div class="aws-ses-rodape">
    <app-button-padrao
      width="100%"
      [label]="salvando ? 'Salvando...' : 'Salvar'"
      backgroundColor="var(--verde-padrao)"
      color="white"
      [disabled]="salvando"
      (buttonClick)="salvar()">
    </app-button-padrao>
  </div>
</div>
